module.exports = __webpack_public_path__ + "static/media/fanyuvo_logo_en.e8654fa1.png";